import { useMemo } from 'react'
import { ActivityStatus } from '@user/features/Activity/constants'
import { Activity } from '@user/features/Activity'

export function useInitValues(activity: Activity | undefined) {
  return useMemo(() => {
    return {
      id: activity ? activity.id : '-1',
      subject: activity ? activity.subject : '',
      description: activity ? activity.description : '',
      activityTypeId: activity ? activity.activityTypeId : '',
      ownerId: activity ? activity.ownerId : '-1',
      startDate:
        activity && activity.startDate ? new Date(activity.startDate) : null,
      startTime:
        activity && activity.startDate ? new Date(activity.startDate) : null,
      dueDate: activity ? new Date(activity.dueDate) : null,
      dueTime: activity ? new Date(activity.dueDate) : null,
      status: activity ? activity.status : ActivityStatus.Todo,
      reminderThreshold: activity ? activity.reminderThreshold : 'None',
    }
  }, [activity])
}
